import axios from 'axios';
import { getTokenHeaders } from '@creditas-lab/auth-sdk';

const fetcher = axios.create({
  baseURL: process.env.CUSTOMER_ONBOARDING_API,
});

class UnauthorizedError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}

type Headers = {
  Authorization: string;
  'Content-Type': string;
  'Accept-Version': string;
  'Legacy-Authorization'?: string;
};

type RequestConfig = {
  headers: Headers;
};

const getRequestConfig = (): RequestConfig => {
  return {
    headers: {
      'Content-Type': 'application/json',
      'Accept-Version': 'v1',
      ...getTokenHeaders(),
    },
  };
};

export { fetcher, UnauthorizedError, getRequestConfig };
